var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "h-full min-w-16 overflow-truncate pr-2" },
    [
      _vm.conversationsExist
        ? _c(
            "ul",
            _vm._l(_vm.conversations, function (item, i) {
              return _c("InboxConversationItem", {
                key: item.id,
                staticClass: "w-full",
                attrs: {
                  index: i,
                  conversation: item,
                  currentUserId: _vm.currentUserId,
                  selected: _vm.selectedConversationId === item.id,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.$emit("conversationSelected", item.id)
                  },
                },
              })
            }),
            1
          )
        : [_vm._m(0)],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "h-full flex text-center" }, [
      _c("h5", { staticClass: "m-auto text-gray-400" }, [
        _vm._v("You don't have any conversations yet"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }